module.exports = __webpack_public_path__ + "Badge_ExerciseExploration-f62432eef58d4ee8db977231adc21a6c.svg";